"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OldDatasService", {
    enumerable: true,
    get: function() {
        return OldDatasService;
    }
});
const _common = require("@nestjs/common");
const _utils = require("~/utils");
const _getAst = /*#__PURE__*/ _interop_require_default(require("~/helpers/getAst"));
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _NcConnectionMgrv2 = /*#__PURE__*/ _interop_require_default(require("~/utils/common/NcConnectionMgrv2"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let OldDatasService = class OldDatasService {
    async dataList(context, param) {
        const { model, view } = await this.getViewAndModelFromRequest(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        const { ast } = await (0, _getAst.default)(context, {
            query: param.query,
            model,
            view
        });
        const listArgs = _extends({}, param.query);
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        try {
            listArgs.sortArr = JSON.parse(listArgs.sortArrJson);
        } catch (e) {}
        return await (0, _utils.nocoExecute)(ast, await baseModel.list(listArgs), {}, listArgs);
    }
    async dataCount(context, param) {
        const { model, view } = await this.getViewAndModelFromRequest(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        const listArgs = _extends({}, param.query);
        try {
            listArgs.filterArr = JSON.parse(listArgs.filterArrJson);
        } catch (e) {}
        return await baseModel.count(listArgs);
    }
    async dataInsert(context, param) {
        const { model, view } = await this.getViewAndModelFromRequest(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        return await baseModel.insert(param.body, param.cookie);
    }
    async dataRead(context, param) {
        const { model, view } = await this.getViewAndModelFromRequest(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view == null ? void 0 : view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        const { ast } = await (0, _getAst.default)(context, {
            query: param.query,
            model,
            view
        });
        return await (0, _utils.nocoExecute)(ast, await baseModel.readByPk(param.rowId), {}, {});
    }
    async dataUpdate(context, param) {
        const { model, view } = await this.getViewAndModelFromRequest(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        return await baseModel.updateByPk(param.rowId, param.body, null, param.cookie);
    }
    async dataDelete(context, param) {
        const { model, view } = await this.getViewAndModelFromRequest(context, param);
        const source = await _models.Source.get(context, model.source_id);
        const baseModel = await _models.Model.getBaseModelSQL(context, {
            id: model.id,
            viewId: view.id,
            dbDriver: await _NcConnectionMgrv2.default.get(source)
        });
        return await baseModel.delByPk(param.rowId, null, param.cookie);
    }
    async getViewAndModelFromRequest(context, req) {
        const base = await _models.Base.getWithInfo(context, req.params.baseId);
        const model = await _models.Model.getByAliasOrId(context, {
            base_id: base.id,
            aliasOrId: req.params.tableName
        });
        const view = req.params.viewName && await _models.View.getByTitleOrId(context, {
            titleOrId: req.params.viewName,
            fk_model_id: model.id
        });
        if (!model) _catchError.NcError.tableNotFound(req.params.tableName);
        return {
            model,
            view
        };
    }
};
OldDatasService = _ts_decorate([
    (0, _common.Injectable)()
], OldDatasService);
